/* Copyright (c) 2020-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Directive } from '@angular/core';
import { ShowHideDirective } from '@angular/flex-layout';

const selector = `
    [fxShow.lt-400], [fxShow.lt-360], [fxShow.lt-340], [fxShow.iphone],
    [fxHide.lt-400], [fxHide.lt-360], [fxHide.lt-340], [fxHide.iphone]
`;
const inputs = [
    'fxShow.lt-400',
    'fxShow.lt-360',
    'fxShow.lt-340',
    'fxShow.iphone',
    'fxHide.lt-400',
    'fxHide.lt-360',
    'fxHide.lt-340',
    'fxHide.iphone'
];

@Directive({ selector, inputs, standalone: true })
export class CustomShowHideDirective extends ShowHideDirective {
    protected inputs = inputs;
}
